<template>
  <section>
    <gs-header title="Quản lý bưu cục">
      <router-link :to="{ name: 'create-post-offices' }" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm
        mới</router-link>
    </gs-header>
    <div class="padding-sm-all">
      <gs-table :ref="postOfficeTable" :table-name="postOfficeTable" data-source="post-offices" :data-params="filters"
        :data-sorted="sorted" :data-sorts="sorts" @remove-filter="removeFilter">
        <section slot="filters">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-select class="display-block " v-model="filters.carrier_id" @change="filter" filterable
                placeholder="Chọn hãng vận chuyển">
                <el-option v-for="carrier in carriers" :key="carrier.id" :label="carrier.name" :value="carrier.id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select class="display-block " v-model="filters.city_id" @change="getFilterDistrict" filterable
                placeholder="Chọn thành phố">
                <el-option v-for="city in cities" :key="city.id" :label="city.name" :value="city.id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select class="display-block " v-model="filters.district_id" @change="filter" filterable
                placeholder="Chọn quận huyện">
                <el-option v-for="district in districts" :key="district.id" :label="district.name" :value="district.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </section>
        <template slot-scope="datas">
          <el-table :data="datas.data" border :row-class-name="tableRowClassName" style="width: 100%">
            >
            <el-table-column label="#" width="80">
              <template slot-scope="scope">
                <small v-if="dataPaginations[postOfficeTable]">{{ (scope.$index + 1) +
                  ((dataPaginations[postOfficeTable].current_page - 1) *
                  dataPaginations[postOfficeTable].per_page)}}</small>
              </template>
            </el-table-column>

            <el-table-column label="Hãng Vận Chuyển  " width="150">
              <template slot-scope="scope">
                <p class="text-center" v-if="scope.row.carrier">
                  <img :src="scope.row.carrier.data.logo_path" width="70"
                    onerror="this.src='https://placeholdit.imgix.net/~text?txtsize=19&amp;txt=img&amp;w=150&amp;h=150'">
                </p>
              </template>
            </el-table-column>

            <el-table-column label="Tên Bưu Cục" width="350">
              <template slot-scope="scope">
                <p>{{ scope.row.name }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Địa Chỉ">
              <template slot-scope="scope">
                <p>{{ scope.row.address }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Thành phố">
              <template slot-scope="scope">
                <p v-if="scope.row.city">{{ scope.row.city.data.name }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Quận huyện">
              <template slot-scope="scope">
                <p v-if="scope.row.district">{{ scope.row.district.data.name }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Số Điện Thoại" width="150">
              <template slot-scope="scope">
                <p><span>{{ scope.row.phone }}</span></p>
              </template>
            </el-table-column>

            <el-table-column width="95">
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <el-tooltip placement="top" content="Nhân bản" class="display-inline" v-if="!scope.row.deleted_at">
                    <router-link class="text-violet padding-all display-inline-block"
                      :to="{ name: 'copy-post-offices', params: { id: scope.row.id } }"><i class="fa fa-files-o"
                        aria-hidden="true"></i></router-link>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Sửa" class="display-inline" v-if="!scope.row.deleted_at">
                    <router-link class="text-orange padding-all display-inline-block"
                      :to="{ name: 'edit-post-offices', params: { id: scope.row.id } }"><i class="fa fa-pencil-square-o"
                        aria-hidden="true"></i></router-link>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Xóa" class="display-inline" v-if="!scope.row.deleted_at">
                    <a @click.prevent="deletePostOffices(scope.row)"
                      class="text-red padding-all display-inline-block cursor-pointer"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Khôi phục" class="display-inline" v-if="scope.row.deleted_at">
                    <a class="text-blue padding-all display-inline-block cursor-pointer" @click="restore(scope.row)"><i
                        class="fa fa-refresh" aria-hidden="true"></i></a>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
    </div>
  </section>
</template>

<script>
import { debounce, keys, forEach } from 'lodash'
import ls from 'local-storage'
import { mapGetters, mapActions } from 'vuex'
import { deletePostOffices, restorePostOffice } from 'src/api/postOffices'
import mixins from './mixins'
export default {

  name: 'PostOffice',
  mixins: [mixins],
  data() {
    return {
      postOfficeTable: 'postOffices',
      filters: {
        carrier_id: '',
        include: 'carrier,city,district',
        sort: 'created_at:-1',
        city_id: '',
        district_id: ''
      },
      sorted: {
        created_at: -1
      },
      sorts: [
        { key: 'created_at', name: 'Ngày tạo' }
      ]
    }
  },
  computed: {
    ...mapGetters('city', ['cities']),
    ...mapGetters('district', ['districts']),
    ...mapGetters('carrier', ['carriers']),
    ...mapGetters('postOffice', ['postOffice'])
  },
  methods: {
    ...mapActions('city', ['getAllCity']),
    ...mapActions('district', ['getAllDistrict']),
    ...mapActions('carrier', ['getAllCarriers']),
    ...mapActions('postOffice', ['setPostOffice']),
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.postOfficeTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.postOfficeTable)
      }
    }, 300),
    removeFilter() {
      if (!this.checkDefaultFilter({
        carrier_id: '',
        include: 'carrier,city,district',
        sort: 'created_at:-1',
        city_id: '',
        district_id: ''
      })) {
        this.reloadGsTable(this.postOfficeTable)
      }
      this.filters = {
        carrier_id: '',
        include: 'carrier,city,district',
        sort: 'created_at:-1',
        city_id: '',
        district_id: ''
      }
    },
    checkDefaultFilter(filters) {
      let diff = false
      let lkeys = keys(filters)
      forEach(lkeys, key => {
        if (filters[key] !== this.filters[key]) {
          this.diff = true
        }
      })
      return diff
    },
    getFilterDistrict(id) {
      this.filters.district_id = ''
      this.getAllDistrict({ city_id: id, limit: -1, sort: 'name:1' })
      this.filter()
    },
    deletePostOffices(postOffice) {
      this.setPostOffice(postOffice)
      this.$confirm(`Bạn chắc chắn muốn xóa bưu cục ${this.postOffice.name}`, 'Xóa bưu cục', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.delPostffice()
      }).catch(() => {

      })
    },
    delPostffice() {
      deletePostOffices(this.postOffice.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Xóa bưu cục thành công'
          })
          this.reloadGsTable(this.postOfficeTable)
        } else {
          this.$message({
            type: 'danger',
            message: 'Xóa bưu cục thất bại'
          })
        }
      })
    },
    tableRowClassName(row) {
      if (row.deleted_at) {
        return 'row-orange'
      }
      return null
    },
    restore(postOffice) {
      this.setPostOffice(postOffice)
      this.$confirm(`Bạn chắc chắn muốn khôi phục bưu cục ${this.postOffice.name}`, 'Khôi phục bưu cục', {
        confirmButtonText: 'Khôi phục',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.resPostOffice()
      }).catch(() => {

      })
    },
    resPostOffice() {
      restorePostOffice(this.postOffice.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Khôi phục bưu cục thành công'
          })
          this.reloadGsTable(this.postOfficeTable)
        } else {
          this.$message({
            type: 'error',
            message: 'Khôi phục bưu cục thất bại'
          })
        }
      })
    }
  },
  mounted() {
    if (ls.get('filters') && ls.get('filters')[this.postOfficeTable]) {
      this.filters = ls.get('filters')[this.postOfficeTable]
      setTimeout(() => {
        ls.set('doFilter', true)
      }, 100)
    }
    this.listenReloadGsTable()
    this.sorted = this.getSorted(this.postOfficeTable)
  },
  beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['districts']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// PostOffice.vue?f51c3dfe